import { gql } from '@apollo/client';

export const DOCUMENT_TYPE_WITH_ALLOWED_STATES_REMOVED_OR_UPDATED = gql`
  subscription documentTypeWithAllowedStatesRemovedOrUpdated {
    documentTypeWithAllowedStatesRemovedOrUpdated {
      documentTypeId
    }
  }
`;

export const IMPORT_DOCUMENT_ALLOWED_STATE_IMPORTED = gql`
  subscription documentAllowedStateRightsImported {
    documentAllowedStateRightsImported
  }
`;
